module.exports = __webpack_public_path__ + "img/astepro_allergy_nasal_spray.ffa89db4.jpg";